<template>
  <div>
    <Card>
      <ui-input
        prepend-inner-icon="fas fa-search"
        type="text"
        :placeholder="t('Search')"
        :hide-details="1"
      ></ui-input>
    </Card>
    <Card>
      <ui-input
        label="Error input"
        placeholder="Error input"
        type="text"
        :error-messages="'error'"
      ></ui-input>
    </Card>
    <Card>
      <ui-input
        label="Text"
        placeholder="Placeholder"
        type="text"
        label-help="Help tooltip"
      ></ui-input>
    </Card>
    <Card>
      <ui-input
        :disabled="true"
        label="Text"
        placeholder="Placeholder"
        type="text"
      ></ui-input>
    </Card>
    <Card>
      <ui-input
        value="12345"
        label="Text"
        placeholder="Placeholder"
        type="text"
        :maxlength="5"
      ></ui-input>
    </Card>
  </div>
</template>

<script setup lang="ts">
import Card from '@/stories/utils/card.vue';

import { useI18n } from '@/composables';

const { t } = useI18n();
</script>
